import { useState } from "react";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TrialStatsTab } from "@/components/admin/teacher-stats/tabs/TrialStatsTab";
import { StudentCareTab } from "@/components/admin/teacher-stats/tabs/StudentCareTab";
import { DepletionStatusTab } from "@/components/admin/teacher-stats/tabs/DepletionStatusTab";
import { TrendingUp, GraduationCap, Users, Clock } from "lucide-react";

const AdminTeacherStatsPage = () => {
  const [activeTab, setActiveTab] = useState("trial");

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AdminSidebar />
        <main className="flex-1 p-6 overflow-auto">
          <div className="max-w-7xl mx-auto space-y-6">
            {/* Header */}
            <div>
              <h1 className="text-3xl font-bold flex items-center gap-2">
                <TrendingUp className="h-8 w-8" />
                สรุปข้อมูลสถิติครู
              </h1>
              <p className="text-muted-foreground mt-1">
                ดูสถิติการสอนทดลองเรียนและอัตราความสำเร็จของครู
              </p>
            </div>

            {/* Tabs */}
            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="trial" className="flex items-center gap-2">
                  <GraduationCap className="h-4 w-4" />
                  <span className="hidden sm:inline">ทดลองเรียน</span>
                  <span className="sm:hidden">ทดลอง</span>
                </TabsTrigger>
                <TabsTrigger value="students" className="flex items-center gap-2">
                  <Users className="h-4 w-4" />
                  <span className="hidden sm:inline">นักเรียนในการดูแล</span>
                  <span className="sm:hidden">นักเรียน</span>
                </TabsTrigger>
                <TabsTrigger value="depletion" className="flex items-center gap-2">
                  <Clock className="h-4 w-4" />
                  <span className="hidden sm:inline">สถานะหมดคอร์ส</span>
                  <span className="sm:hidden">หมดคอร์ส</span>
                </TabsTrigger>
              </TabsList>
              
              {/* Lazy Load: render only the active tab */}
              {activeTab === "trial" && (
                <TabsContent value="trial" forceMount className="mt-6">
                  <TrialStatsTab />
                </TabsContent>
              )}
              {activeTab === "students" && (
                <TabsContent value="students" forceMount className="mt-6">
                  <StudentCareTab />
                </TabsContent>
              )}
              {activeTab === "depletion" && (
                <TabsContent value="depletion" forceMount className="mt-6">
                  <DepletionStatusTab />
                </TabsContent>
              )}
            </Tabs>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

export default AdminTeacherStatsPage;
